import { RootState } from '../../store/rootReducer';

export const LegalFooterContentSelector = (state: RootState) => state.content.legalFooter;
